<!--
  A Bulma-styled loading spinner to be used when page content is loading
-->
<template>
  <div style="text-align: center">
    <LoadingSpinner size="large" style="margin-bottom: 10px; margin-top: 30px"/>
    <h1>Loading...</h1>
  </div>
</template>

<script lang="ts" setup>
</script>

<style scoped>
  div {
    width: 100%;
    height: 100%;
  }

  h1 {
    text-align: center;
  }
</style>